import 'antd/dist/reset.css';
import './App.css'; 
import './SearchBox.css'; 
import './CustomTable.css'; 
import './Queries.css'; 
import './About.css'; 
import './Requirements.css'; 
import './Workflow.css'; 
import './Availables.css'; 
import './Reports.css'; 

import { Routes, Route, Link, useNavigate, useLocation, Navigate } from 'react-router-dom';


import {
  MenuOutlined,
  InfoCircleOutlined,
  NotificationOutlined,
  CheckSquareOutlined,
  ApartmentOutlined,
  BookOutlined,
  BarChartOutlined,
  MailOutlined,
  UserOutlined,
  DashboardOutlined,
  PlusCircleOutlined,
  CheckCircleOutlined,
  LogoutOutlined,
  SearchOutlined,
  FileTextOutlined,
  DollarOutlined,
  UnorderedListOutlined,
  PoweroffOutlined,
} from '@ant-design/icons';
import Cookies from "js-cookie";



import SearchComponent from './Components/SearchComponent';
import CreateUserComponent from './Components/CreateUserComponent';
import LoginUserComponent from './Components/LoginUserComponent';
import RequirementsComponent from './Components/RequirementsComponent';
import WorkflowComponent from './Components/WorkflowComponent';
import DashboardComponent from './Components/DashboardComponent';
import AboutComponent from './Components/AboutComponent';
import NewsComponent from './Components/NewsComponent';  // 🔹 Importa NewsComponent
import DiamondComponent from './Components/DiamondComponent';
import APCComponent from './Components/APCComponent';
import JournalFindersComponent from './Components/JournalFindersComponent';
import PolicyComponent from './Components/PolicyComponent';
import IIPPIRComponent from './Components/IIPPIRComponent';
import UsageComponent from './Components/UsageComponent';

import { Layout, Menu, Row, Col, Button, Drawer, Switch } from 'antd';
import { useEffect, useState } from 'react';
import AvailablesComponent from './Components/AvailablesComponent';
import AssignedComponent from './Components/AssignedComponent';
import ReportsComponent from './Components/ReportsComponent';
import QueriesComponent from './Components/QueriesComponent';
import AddComponent from './Components/AddComponent';
import ApprovedComponent from './Components/ApprovedComponent';

import React from 'react';
import { notification } from 'antd';
import { backendURL } from './Globals';

import buo from './buo.png';
import unioviblanco from './unioviblanco.png';

const SIDER_WIDTH = 240;

let App = () => {
  const [api, contextHolder] = notification.useNotification();
  let [login, setLogin] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [statsVisible, setStatsVisible] = useState(() => localStorage.getItem('statsVisible') !== 'false');

  const toggleStats = () => {
    setStatsVisible(prev => {
      const next = !prev;
      localStorage.setItem('statsVisible', String(next));
      return next;
    });
  };

  let navigate = useNavigate();
  let location = useLocation();
  let { Header, Content, Footer, Sider } = Layout;

  useEffect(() => {
    checkLogin();
  }, []);

  // Registrar visita única al cargar / navegar (fire-and-forget)
  useEffect(() => {
    fetch(backendURL + '/usage/visit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: location.pathname }),
    }).catch(() => {});
  }, [location.pathname]);

  let checkLogin = async () => {
    const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
    if (!apiKey) { setLogin(false); return; }
    try {
      let response = await fetch(backendURL + "/users/checklogin?apiKey=" + apiKey);
      if (response.ok) {
        setLogin(true);
      } else {
        setLogin(false);
        Cookies.remove("apiKey");
        localStorage.removeItem("apiKey");
        const protectedRoutes = ["/assigned", "/dashboards", "/add", "/approved"];
        if (protectedRoutes.some(r => location.pathname.startsWith(r))) {
          navigate("/login");
        }
      }
    } catch {
      // Red no disponible: mantener estado actual sin redirigir
    }
  };
  

  let createNotification = (type = "error", msg, placement = "top") => {
    api[type]({
      message: msg,
      description: msg,
      placement
    });
  };

  const handleLogout = async () => {
    const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");

    if (!apiKey) return;

    try {
        // Ahora usamos POST en lugar de GET y pasamos la API Key en los headers
        await fetch(`${backendURL}/users/logout`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${apiKey}`, // 🔹 Ahora se envía en los headers
            },
        });
    } catch (error) {
        console.error("Error al cerrar sesión:", error);
    }

    // 🔹 Limpiar el almacenamiento local
    Cookies.remove("apiKey");
    localStorage.removeItem("apiKey");

    // 🔹 Notificar a los demás componentes para actualizar su estado
    window.dispatchEvent(new Event("storage"));

    // 🔹 Actualizar el estado de autenticación si usas `setLogin`
    if (setLogin) {
        setLogin(false);
    }

    // 🔹 Redirigir al usuario a la página "/about" tras cerrar sesión
    navigate("/about");
};

  const getMenuKey = () => {
    if (location.pathname === '/' || location.pathname.startsWith('/search')) return "Menusearch";
    if (location.pathname.startsWith('/about')) return "menuAbout";
    if (location.pathname.startsWith("/requeriments")) return "menuRequeriments";
    if (location.pathname.startsWith("/search")) return "Menusearch";
    if (location.pathname.startsWith("/workflow")) return "MenuWorflow";
    if (location.pathname.startsWith("/assigned")) return "MenuAssigned";
    if (location.pathname.startsWith("/dashboards")) return "MenuDashboard";
    if (location.pathname.startsWith("/availables")) return "MenuAvailables";
    if (location.pathname.startsWith("/reports")) return "MenuReports";
    if (location.pathname.startsWith("/add")) return "MenuAdd";
    if (location.pathname.startsWith("/approved")) return "MenuApproved";
    if (location.pathname.startsWith("/news")) return "menuNews";
    if (location.pathname.startsWith("/diamonds")) return "MenuDiamonds";
    if (location.pathname.startsWith("/apcs")) return "MenuAPCs";
    if (location.pathname.startsWith("/journal-finders")) return "MenuJournalFinders";
    if (location.pathname.startsWith("/politica-autoarchivo")) return "MenuPolicy";
    if (location.pathname.startsWith("/ayuda-iippir")) return "MenuIIPPIR";
    if (location.pathname.startsWith("/usage")) return "MenuUsage";
    return null;
  };

  const mainTabItems = [
    { key: 'Menusearch',   label: <Link to="/search">Revistas Acuerdos Transformativos</Link> },
    { key: 'MenuDiamonds', label: <Link to="/diamonds">Revistas Diamante</Link> },
  ];

  const siderItems = [
    {
      type: 'group',
      label: 'INFORMACIÓN',
      children: [
        { key: 'menuAbout',        icon: <InfoCircleOutlined />,    label: <Link to="/about">Información</Link> },
        { key: 'menuRequeriments', icon: <CheckSquareOutlined />,   label: <Link to="/requeriments">Requisitos</Link> },
        { key: 'MenuWorflow',      icon: <ApartmentOutlined />,     label: <Link to="/workflow">Procedimiento</Link> },
        { key: 'menuNews',         icon: <NotificationOutlined />,  label: <Link to="/news">Novedades</Link> },
        statsVisible && { key: 'MenuReports', icon: <BarChartOutlined />, label: <Link to="/reports">Estadísticas</Link> },
        !login && { key: 'MenuQueries', icon: <MailOutlined />,     label: <Link to="/queries">Contacta</Link> },
      ].filter(Boolean),
    },
    {
      type: 'group',
      label: 'RECURSOS',
      children: [
        { key: 'MenuAvailables',   icon: <UnorderedListOutlined />, label: <Link to="/availables">APCs disponibles</Link> },
        { key: 'MenuJournalFinders', icon: <SearchOutlined />,        label: <Link to="/journal-finders">Journal Finders</Link> },
        { key: 'MenuAPCs',         icon: <DollarOutlined />,        label: <Link to="/apcs">Precios públicos APCs</Link> },
        { key: 'MenuPolicy',         icon: <FileTextOutlined />,      label: <Link to="/politica-autoarchivo">Políticas autoarchivo</Link> },
        { key: 'MenuIIPPIR',          icon: <BookOutlined />,          label: <Link to="/ayuda-iippir">Ayuda IIPPIR</Link> },
      ].filter(Boolean),
    },
    login && {
      type: 'group',
      label: 'ADMINISTRACIÓN',
      children: [
        { key: 'MenuAssigned',   icon: <UserOutlined />,          label: <Link to="/assigned">Asignados</Link> },
        { key: 'MenuDashboard',  icon: <DashboardOutlined />,     label: <Link to="/dashboards">Dashboards</Link> },
        { key: 'MenuAdd',        icon: <PlusCircleOutlined />,    label: <Link to="/add">Añadir</Link> },
        { key: 'MenuApproved',   icon: <CheckCircleOutlined />,   label: <Link to="/approved">Aprobados</Link> },
        {
          key: 'MenuToggleStats',
          icon: <PoweroffOutlined style={{ color: statsVisible ? '#52c41a' : '#ff4d4f' }} />,
          label: (
            <span
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
              onClick={(e) => { e.stopPropagation(); e.preventDefault(); toggleStats(); }}
            >
              Estadísticas
              <Switch size="small" checked={statsVisible} style={{ marginLeft: 8, pointerEvents: 'none' }} />
            </span>
          ),
        },
        { key: 'MenuUsage',      icon: <BarChartOutlined />,      label: <Link to="/usage">Uso de la web</Link> },
        { key: 'MenuDisconect',  icon: <LogoutOutlined />,        label: <Link to="#" onClick={handleLogout}>Salir</Link> },
      ],
    },
  ].filter(Boolean);

  // ── Layout mínimo para la página de login (sin sidebar ni menú) ──
  if (location.pathname === '/login' && login) return <Navigate to="/search" replace />;
  if (location.pathname === '/login') {
    return (
      <>
        {contextHolder}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Layout style={{ minHeight: '100vh' }}>
          <Header className='barra-uniovi' style={{ lineHeight: 'normal' }}>
            <div style={{ paddingLeft: 24 }}>
              <h1 className="titulo">Publicar en Acceso Abierto</h1>
              <a href="https://www.uniovi.es/" target="_blank" rel="noopener noreferrer">
                <img src={unioviblanco} className="uniovi-logo" alt="Logo UniOvi" />
              </a>
            </div>
          </Header>
          <Content style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            minHeight: 'calc(100vh - 64px)',
            background: 'linear-gradient(160deg, #e8f4f8 0%, #f5f8fa 60%, #eaf3f7 100%)',
            padding: '48px 24px',
          }}>
            <LoginUserComponent setLogin={setLogin} createNotification={createNotification} />
          </Content>
        </Layout>
      </>
    );
  }

  return (
    <>
      {contextHolder}
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      <Layout style={{ minHeight: '100vh', backgroundColor: '#FFFFFF' }}>

        {/* ── Cabecera principal (ancho total) ── */}
        <Header className='barra-uniovi' style={{ lineHeight: 'normal' }}>
          <div style={{ paddingLeft: SIDER_WIDTH }}>
            <h1 className="titulo">Publicar en Acceso Abierto</h1>
            <a href="https://www.uniovi.es/" target="_blank" rel="noopener noreferrer">
              <img src={unioviblanco} className="uniovi-logo" alt="Logo UniOvi" />
            </a>
          </div>
        </Header>

        {/* ── Barra de pestañas (ancho total, sobre sidebar y contenido) ── */}
        <div className="main-tab-bar">
          <Row>
            <Col xs={0} sm={0} md={24}>
              <Menu mode="horizontal" selectedKeys={[getMenuKey()]}
                className="main-tab-menu" items={mainTabItems} />
            </Col>
            <Col xs={24} sm={24} md={0} style={{ textAlign: 'right', padding: '0.5em' }}>
              <Button icon={<MenuOutlined />} onClick={() => setMenuOpen(true)} />
            </Col>
          </Row>
          <Drawer title="Menú" placement="right" closable onClose={() => setMenuOpen(false)} open={menuOpen}>
            <Menu mode="vertical" selectedKeys={[getMenuKey()]} onClick={() => setMenuOpen(false)}
              items={[...mainTabItems, ...siderItems]} />
          </Drawer>
        </div>

        {/* ── Cuerpo: sidebar izquierdo + contenido ── */}
        <Layout style={{ backgroundColor: '#FFFFFF' }}>

          {/* Sidebar vertical fijo (siempre visible en desktop) */}
          <Sider width={SIDER_WIDTH} className="main-sider" breakpoint="md" collapsedWidth={0}>
            <Menu mode="inline" selectedKeys={[getMenuKey()]}
              style={{ height: '100%', borderRight: 0 }}
              items={siderItems} />
          </Sider>

          <Content style={{ backgroundColor: '#FFFFFF' }}>
            <Routes>
              <Route path="/" element={<Navigate to="/search" replace />} />
              <Route path="/register" element={<CreateUserComponent />} />
              <Route path="/search" element={<SearchComponent />} />
              <Route path="/requeriments" element={<RequirementsComponent />} />
              <Route path="/workflow" element={<WorkflowComponent />} />
              <Route path="/dashboards" element={<DashboardComponent />} />
              <Route path="/about" element={<AboutComponent />} />
              <Route path="/news" element={<NewsComponent />} />
              <Route path="/assigned" element={<AssignedComponent />} />
              <Route path="/availables" element={<AvailablesComponent />} />
              <Route path="/reports" element={statsVisible ? <ReportsComponent /> : <Navigate to="/about" replace />} />
              <Route path="/queries" element={<QueriesComponent />} />
              <Route path="/add" element={<AddComponent />} />
              <Route path="/approved" element={<ApprovedComponent />} />
              <Route path="/diamonds" element={<DiamondComponent />} />
              <Route path="/apcs" element={<APCComponent />} />
              <Route path="/journal-finders" element={<JournalFindersComponent />} />
              <Route path="/politica-autoarchivo" element={<PolicyComponent />} />
              <Route path="/ayuda-iippir" element={<IIPPIRComponent />} />
              <Route path="/login" element={<LoginUserComponent setLogin={setLogin} createNotification={createNotification} />} />
              <Route path="/usage" element={login ? <UsageComponent /> : <Navigate to="/login" replace />} />
            </Routes>
          </Content>

        </Layout>

        <Footer className='FooterAnt'>
          <hr className='hr-baja' />
          <div className='FooterContent'>
            <img src={buo} alt="Logo Biblioteca de la Universidad de Oviedo" className='footer-logo' />
            <div className='footer-text'>
              <p className='footer-institution'>Biblioteca de la Universidad de Oviedo</p>
              <p className='footer-subdirection'>Subdirección Técnica, de Cooperación Bibliotecaria y Servicios a Distancia</p>
              <p className='footer-address'>
                Campus de El Milán · Edif. Administración, 4ª planta · C/ Francisco Rodríguez García s/n · 33011 Oviedo
                &ensp;·&ensp;
                <a href="tel:+34985104166">985 104 166</a>
              </p>
              <p className='footer-attribution'>
                Datos JCR: <a href="https://jcr.clarivate.com" target="_blank" rel="noopener noreferrer">Clarivate</a>
                &ensp;·&ensp;
                Datos SJR: <a href="https://www.scimagojr.com" target="_blank" rel="noopener noreferrer">Scimago / Elsevier</a>
                &ensp;·&ensp;
                Revistas OA: <a href="https://doaj.org" target="_blank" rel="noopener noreferrer">DOAJ</a>
                &ensp;·&ensp;
                Uso bajo licencia institucional de la Universidad de Oviedo
              </p>
              <p className='footer-license'>
                <a href="https://creativecommons.org/licenses/by/4.0/deed.es" target="_blank" rel="noopener noreferrer">
                  Licencia Creative Commons CC BY 4.0
                </a>
              </p>
            </div>
          </div>
        </Footer>
      </Layout>
    </>
  );
}

export default App;


